import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import SEO from "@/components/SEO";
import useTranslation from "@/hooks/useTranslation";
import useScript from "../hooks/useScript";

const Contact = () => {
  const { t } = useTranslation();
  
  useScript({
    src: 'https://form.jotform.com/jsform/251804698102053',
    containerId: 'jotform-container'
  });

  return (
    <div className="min-h-screen py-16">
      <SEO 
        title={`${t('contact')} - NuWav Laboratories`}
        description={t('getInTouch')}
        keywords="contact, laboratory services, medical testing inquiries, location, Carrollton TX, NuWav Laboratories contact"
        canonicalUrl="https://nuwavlabs.com/contact"
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold mb-4">{t('contactUs')}</h1>
          <p className="text-xl text-gray-600">{t('getInTouch')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Jotform */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h2 className="text-2xl font-semibold mb-6">{t('sendMessage')}</h2>
            <div id="jotform-container">
              {/* Jotform will load here */}
            </div>
          </motion.div>

          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            className="space-y-8"
          >
            <ContactCard
              icon={<MapPin className="w-6 h-6 text-[#40E0D0]" />}
              title={t('address')}
              content="2015 Midway Rd Bldg 111, Carrollton, TX 75006"
            />
            <ContactCard
              icon={<Phone className="w-6 h-6 text-[#40E0D0]" />}
              title={t('phone')}
              content="972-327-8857"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

const ContactCard = ({ icon, title, content }) => (
  <div className="bg-white p-6 rounded-lg shadow-lg">
    <div className="flex items-center mb-4">
      {icon}
      <h3 className="text-xl font-semibold ml-4">{title}</h3>
    </div>
    <p className="text-gray-600 whitespace-pre-line">{content}</p>
  </div>
);

export default Contact;
